import { useNavigate, useLocation } from 'react-router-dom'
import classes from './betKursButtons.module.css'
import { useState, useEffect, useRef } from 'react'
import Axios from 'axios'

const SERVER_URL = process.env.REACT_APP_SERVER_URL

const configMap = {
  betcourse: {
    route: '/bet_kurs',
    title: 'BET KURS',
    noun: 'kurseva',
    noun2: 'kurs',
  },
  betsystem: {
    route: '/bet_sistemi',
    title: 'BET SISTEMI',
    noun: 'sistema',
    noun2: 'sisteme',
  },
  betstrategy: {
    route: '/bet_strategije',
    title: 'BET STRATEGIJE',
    noun: 'strategija',
    noun2: 'strategije',
  },
}

const BetKurs = ({ type = 'betcourse' }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [items, setItems] = useState([])
  const [isListVisible, setIsListVisible] = useState(false)
  const ref = useRef()

  const {
    route: routeBase,
    title: courseTitle,
    noun,
    noun2,
  } = configMap[type] || configMap['betcourse']

  useEffect(() => {
    fetchItems()
  }, [type])

  const fetchItems = async () => {
    try {
      const response = await Axios.get(
        `${SERVER_URL}/betcourses-menu?type=${type}`
      )
      setItems(response.data)
    } catch (error) {
      console.error('Error fetching items:', error)
    }
  }

  const toggleListVisibility = () => {
    setIsListVisible((prevState) => !prevState)
  }

  useEffect(() => {
    if (isListVisible) {
      ref.current?.scrollIntoView()
    }
  }, [isListVisible])

  const handleItemClick = (id, route) => {
    setIsListVisible(false)
    if (id === 'landing') {
      navigate(routeBase)
    } else {
      navigate(`${routeBase}/${id}`)
    }
  }

  const isItemSelected = (id) => {
    if (id === 'landing') return location.pathname === routeBase
    return location.pathname === `${routeBase}/${id}`
  }

  return (
    <>
      <div className={classes.toggleButtonContainer}>
        <button onClick={toggleListVisibility} className={classes.toggleButton}>
          {isListVisible ? `Zatvori listu ${noun}` : `Pogledaj listu ${noun}`}
        </button>
      </div>
      <div
        className={`${classes.container} ${
          isListVisible ? classes.visible : ''
        }`}
        ref={ref}
      >
        <ul>
          <h3 className={classes.liTitle}>{courseTitle}</h3>

          <li
            onClick={() => handleItemClick('landing')}
            className={`${classes.liItem} ${
              isItemSelected('landing') ? classes.selected : ''
            }`}
          >
            Uvod u {noun2}
          </li>

          {items &&
            items.length > 0 &&
            items.map((item, index) => (
              <div key={index}>
                <li className={classes.liTitle}>
                  <p style={{ margin: '0', padding: '0' }}>{item.title}</p>
                </li>
                {item.items &&
                  item.items.length > 0 &&
                  item.items.map((courseitem, courseindex) => (
                    <li
                      key={courseindex}
                      onClick={() => handleItemClick(courseitem._id)}
                      className={`${classes.liItem} ${
                        isItemSelected(courseitem._id) ? classes.selected : ''
                      }`}
                    >
                      {courseitem.title}
                    </li>
                  ))}
              </div>
            ))}
        </ul>
      </div>
    </>
  )
}

export default BetKurs
